import {
  TaskDecisionBodyDTO,
  TimeFormatEnum,
  TimesheetApi,
  TimesheetApiTimesheetGetTimesheetDashboardRequest,
  TimesheetApiTimesheetUpdateTaskDecisionRequest
} from '../api-client/generated/api';
import {
  formatMillisecondsToHHMMSS,
  formatSumTime,
  formattedTime,
  formattedTimeDateTime
} from '../utils/calendarHelper';
import {
  convertUTCToLocalTimeZone,
  convertUTCToLocalTimeZoneHHMMSS,
  formatDate
} from '../utils/general';

const apiCaller = new TimesheetApi();

const reviewHeader = [
  { align: 'center', columnName: 'technician', text: 'Technician' },
  { align: 'center', columnName: 'taskName', text: 'Item' },
  { align: 'center', columnName: 'typeText', text: 'Project type' },
  { align: 'center', columnName: 'day', text: 'Day' },
  { align: 'center', columnName: 'travelTime', text: 'Travel time' },
  // { align: 'center', columnName: 'scheduledStart', text: 'Scheduled Start' },
  { align: 'center', columnName: 'actualStart', text: 'Actual Start' },
  // { align: 'center', columnName: 'scheduledEnd', text: 'Scheduled End' },
  { align: 'center', columnName: 'actualEnd', text: 'Actual End' },
  { align: 'center', columnName: 'scheduledTotal', text: 'Scheduled Total' },
  { align: 'center', columnName: 'actualTotal', text: 'Actual Total' },
  { align: 'center', columnName: 'variance', text: 'Variance %' },
  { align: 'center', columnName: 'varianceActual', text: 'Variance Actual' },
  { align: 'center', text: '' }
];

export const taskListFormater = (response: any, timeFormat?: string) => {
  return response.data.map((taskIteration: any) => {
    const auxTaskDataList = taskIteration?.tasks.map(
      (taskIterationData: any) => {
        console.log('==>> taskIterationData', taskIterationData);
        const auxServiceTime = taskIterationData?.leadServiceTask
          ? taskIterationData?.leadServiceTask?.service?.serviceTime
          : taskIterationData?.leadServiceTime;
        const auxTravelTIme =
          taskIterationData?.calendarEvent?.travelTimeIterations[0]
            ?.travelTimeInHours ||
          auxServiceTime?.travelTime ||
          '0.00';
        const travelTimeInMilliseconds = formatMillisecondsToHHMMSS(
          taskIterationData?.calendarEvent?.travelTimeIterations[0]
            ?.travelTimeInMilliseconds
        );
        const timezone =
          (taskIterationData?.calendarEvent &&
            taskIterationData?.calendarEvent?.leadServiceTime?.lead?.address
              ?.timezoneIANA) ||
          (taskIterationData?.calendarEvent &&
            taskIterationData?.calendarEvent?.leadServiceTime?.lead?.address
              ?.timezone) ||
          (taskIterationData?.leadServiceTask &&
            taskIterationData?.leadServiceTask?.service?.serviceTime?.lead
              ?.address?.timezoneIANA) ||
          Intl.DateTimeFormat().resolvedOptions().timeZone;
        const task = {
          actualEnd: convertUTCToLocalTimeZoneHHMMSS(
            taskIterationData?.endTime,
            timezone,
            // eslint-disable-next-line no-underscore-dangle
            timeFormat === TimeFormatEnum._24h
          ),

          actualStart: convertUTCToLocalTimeZoneHHMMSS(
            taskIterationData?.startTime,
            timezone,
            // eslint-disable-next-line no-underscore-dangle
            timeFormat === TimeFormatEnum._24h
          ),
          actualTotal: Number(taskIterationData.hoursWorked),
          clientName: `${taskIterationData?.calendarEvent?.leadServiceTime?.lead?.client?.firstName}
            ${taskIterationData?.calendarEvent?.leadServiceTime?.lead?.client?.lastName}`,
          closedBy: taskIterationData?.closedBy,
          closer: taskIterationData?.closer,
          companyName:
            taskIterationData?.calendarEvent?.leadServiceTime?.lead?.client
              ?.businessName,
          day: formatDate(taskIterationData.startTime),
          id: taskIterationData.id,
          laborHourCost: taskIterationData?.laborHourCost || 0,
          laborTotalCost: taskIterationData.laborTotalCost,
          millisecondsWorked: formatMillisecondsToHHMMSS(
            taskIterationData.millisecondsWorked
          ),
          originalTask:
            taskIterationData.type === 'Regular'
              ? taskIterationData?.calendarEvent?.leadService?.tasks
              : taskIterationData?.leadServiceTask?.name,
          pauseIterations: taskIterationData.pauseIterations || [],
          pauseTimeMs: (() => {
            const pauseMs =
              taskIterationData.pauseIterations?.reduce(
                (total: number, pause: any) => {
                  if (pause.startTime && pause.endTime) {
                    const start = new Date(pause.startTime).getTime();
                    const end = new Date(pause.endTime).getTime();
                    return total + (end - start);
                  }
                  return total;
                },
                0
              ) || 0;
            return formatMillisecondsToHHMMSS(pauseMs.toString());
          })(),
          projectName:
            taskIterationData?.calendarEvent?.leadServiceTime?.lead?.name,
          projectType: taskIterationData.type,
          scheduledEnd: formattedTime(
            auxServiceTime?.endTime,
            undefined,
            timeFormat
          ),
          scheduledStart: formattedTime(
            auxServiceTime?.startTime,
            undefined,
            timeFormat
          ),
          scheduledTotal: Number(taskIterationData.hoursScheduled),
          serviceName:
            taskIterationData.type === 'Regular'
              ? taskIterationData?.calendarEvent?.leadService?.name
              : taskIterationData?.leadServiceTask?.service.name,
          startedBy: taskIterationData?.startedBy,
          starter: taskIterationData?.starter,
          status: taskIterationData.status,
          taskName: taskIterationData?.leadServiceTask
            ? taskIterationData?.leadServiceTask?.name
            : taskIterationData?.calendarEvent?.leadService?.name,
          technician: `${taskIteration?.technician?.firstName} ${taskIteration?.technician?.lastName}`,
          technicianInformation: taskIteration?.technician,
          timeFormat,
          timezone,
          travelTime: auxTravelTIme,
          travelTimeInMilliseconds,
          type: taskIterationData?.leadServiceTask
            ? 'taskIteration'
            : 'calendarEventIteration',
          typeText: taskIterationData?.type,
          variance: Number(taskIterationData.variance),
          varianceActual: taskIterationData.variance,
          variancePercentage: (
            ((taskIterationData.hoursWorked -
              taskIterationData.hoursScheduled) /
              taskIterationData.hoursScheduled) *
            100
          ).toFixed(0),
          workedTimeMs: (() => {
            const pauseMs =
              taskIterationData.pauseIterations?.reduce(
                (total: number, pause: any) => {
                  if (pause.startTime && pause.endTime) {
                    const start = new Date(pause.startTime).getTime();
                    const end = new Date(pause.endTime).getTime();
                    return total + (end - start);
                  }
                  return total;
                },
                0
              ) || 0;
            const workedMs = taskIterationData.millisecondsWorked - pauseMs;
            return formatMillisecondsToHHMMSS(workedMs.toString());
          })()
        };

        if (task.variancePercentage.endsWith('.00')) {
          task.variancePercentage = task.variancePercentage.slice(0, -3);
        }

        return task;
      }
    );

    const totalTravelTimes = auxTaskDataList.reduce(
      (sum: number, task: any) => {
        const [hours, minutes, seconds] = task.travelTimeInMilliseconds
          .split(':')
          .map(Number);
        const travelTimeInMilliseconds =
          (hours * 3600 + minutes * 60 + seconds) * 1000;
        return sum + travelTimeInMilliseconds;
      },
      0
    );

    const formattedTotalTravelTimes =
      formatMillisecondsToHHMMSS(totalTravelTimes);

    return {
      dataList: auxTaskDataList,
      email: taskIteration?.technician?.email,
      hourlyRate: taskIteration?.technician?.rate,
      id: taskIteration?.technician?.id,
      phoneNumber: taskIteration?.technician?.phoneNumber,
      technician: `${taskIteration?.technician?.firstName} ${taskIteration?.technician?.lastName}`,
      technicianPaymentTotal:
        typeof taskIteration?.values?.technicianPaymentTotal === 'string'
          ? Number(taskIteration?.values?.technicianPaymentTotal)
          : taskIteration?.values?.technicianPaymentTotal || 0,
      totalHoursScheduled:
        Number(taskIteration?.values?.totalHoursScheduled) || 0,
      totalHoursWorked: Number(taskIteration?.values?.totalHoursWorked),
      totalPauseMs: Number(taskIteration?.values?.totalPauseMs) || 0,
      totalTravelTimes: formattedTotalTravelTimes
    };
  });
};

const getTimesheetDashboard = async (params: any): Promise<any> => {
  const auxParams: TimesheetApiTimesheetGetTimesheetDashboardRequest = {
    fromDate: params.fromDate,
    toDate: params.toDate
  };

  const response = await apiCaller.timesheetGetTimesheetDashboard(auxParams);
  const { data } = response;
  return data;
};

const getTechnicianTimesheetDashboard = async (params: any): Promise<any> => {
  const auxParams: TimesheetApiTimesheetGetTimesheetDashboardRequest = {
    fromDate: params.fromDate,
    toDate: params.toDate
  };

  const response = await apiCaller.timesheetGetTechnicianTimesheetDashboard(
    auxParams
  );
  const { data } = response;
  return data;
};

const getTimesheetTasks = async (params: any): Promise<any> => {
  const auxParams: TimesheetApiTimesheetGetTimesheetDashboardRequest = {
    fromDate: params.fromDate,
    toDate: params.toDate
  };

  const response = await apiCaller.timesheetGetTimesheetTasks(auxParams);
  const taskIterationsList = taskListFormater(response, params?.timeFormat);

  return taskIterationsList;
};

const getTechnicianTimesheetTasks = async (params: any): Promise<any> => {
  const auxParams: TimesheetApiTimesheetGetTimesheetDashboardRequest = {
    fromDate: params.fromDate,
    toDate: params.toDate
  };

  const response = await apiCaller.timesheetGetTechnicianTimesheetTasks(
    auxParams
  );
  const taskIterationsList = taskListFormater(response, params?.timeFormat);

  return taskIterationsList;
};

const getTaskToReviewForOperator = async (params: any): Promise<any> => {
  const response = await apiCaller.timesheetGetTaskToReviewForOperator();

  const taskIterationsList = taskListFormater(response, params?.timeFormat);

  return taskIterationsList;
};

const getTechnicianTaskToReviewForOperator = async (
  params: any
): Promise<any> => {
  const response =
    await apiCaller.timesheetGetTechnicianTaskToReviewForOperator();
  const taskIterationsList = taskListFormater(response, params?.timeFormat);

  return taskIterationsList;
};

const updateTaskDecision = async (params: any): Promise<any> => {
  const auxParams: TimesheetApiTimesheetUpdateTaskDecisionRequest = {
    taskDecisionBodyDTO: {
      actualTotal: params.actualTotal,
      approvalStatus: params.approvalStatus
    } as TaskDecisionBodyDTO,
    taskIterationId: params.taskIterationId
  };

  if (params.type === 'calendarEventIteration') {
    const response =
      await apiCaller.timesheetUpdateCalendarEventIterationDecision(auxParams);
    const { data } = response;

    return data;
  }

  const response = await apiCaller.timesheetUpdateTaskDecision(auxParams);
  const { data } = response;

  return data;
};

/**
 * Shape flat SR assignment rows (from /timesheet/sr-tasks) into the same
 * technician-grouped structure that taskListFormater produces, so
 * TimesheetReportTable can render them unchanged.
 */
export const srTaskListFormatter = (srRows: any[]): any[] => {
  const byTech: Record<string, any> = {};

  srRows.forEach((row: any) => {
    const techId = row.technician?.id ?? 'unknown';
    if (!byTech[techId]) {
      byTech[techId] = {
        dataList: [],
        email: row.technician?.email ?? '',
        hourlyRate: row.technician?.rate ?? 0,
        id: techId,
        isSR: true,
        phoneNumber: '',
        technician: [row.technician?.firstName, row.technician?.lastName]
          .filter(Boolean)
          .join(' '),
        technicianPaymentTotal: 0,
        totalHoursScheduled: 0,
        totalHoursWorked: 0,
        totalPauseMs: 0,
        totalTravelTimes: '00:00:00'
      };
    }

    const worked = row.hoursWorked ?? 0;
    const clientName = row.client?.businessName
      ? row.client.businessName
      : [row.client?.firstName, row.client?.lastName].filter(Boolean).join(' ');

    byTech[techId].dataList.push({
      actualEnd: row.endTime
        ? new Date(row.endTime).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
          })
        : '--',
      actualStart: row.startTime
        ? new Date(row.startTime).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
          })
        : '--',
      actualTotal: worked,
      clientName,
      companyName: clientName,
      day: row.startTime
        ? new Date(row.startTime).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            weekday: 'short',
            year: 'numeric'
          })
        : '--',
      id: row.id,
      isSR: true,
      laborHourCost: row.laborHourCost ?? 0,
      laborTotalCost: row.laborTotalCost ?? 0,
      pauseIterations: [],
      pauseTimeMs: '00:00:00',
      projectName: '⚡ Service Request',
      projectType: 'SR',
      scheduledEnd: '--',
      scheduledStart: '--',
      scheduledTotal: 0,
      serviceName: '⚡ Service Request',
      serviceRequestId: row.serviceRequestId,
      startedBy: null,
      starter: null,
      status: 'Completed',
      taskName: row.taskName?.replace(/^SR:\s*/i, '').trim(),
      technician: [row.technician?.firstName, row.technician?.lastName]
        .filter(Boolean)
        .join(' '),
      technicianInformation: row.technician,
      travelTime: '0.00',
      travelTimeInMilliseconds: '00:00:00',
      type: 'SR',
      typeText: 'SR',
      variance: 0,
      varianceActual: 0,
      variancePercentage: 'N/A',
      workedTimeMs: (() => {
        const ms = worked * 3600 * 1000;
        const h = Math.floor(ms / 3600000);
        const m = Math.floor((ms % 3600000) / 60000);
        const s = Math.floor((ms % 60000) / 1000);
        return `${String(h).padStart(2, '0')}:${String(m).padStart(
          2,
          '0'
        )}:${String(s).padStart(2, '0')}`;
      })()
    });

    byTech[techId].totalHoursWorked += worked;
    byTech[techId].technicianPaymentTotal += row.laborTotalCost ?? 0;
  });

  return Object.values(byTech);
};

export default {
  getTaskToReviewForOperator,
  getTechnicianTaskToReviewForOperator,
  getTechnicianTimesheetDashboard,
  getTechnicianTimesheetTasks,
  getTimesheetDashboard,
  getTimesheetTasks,
  reviewHeader,
  updateTaskDecision
};
